var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "\n        currentAddressTipMain\n    ",
      style: {
        color: _vm.fontColor
      },
      on: { click: _vm.goToAddressManager }
    },
    [
      _c("i", { staticClass: "iconfont icon-weizhi addressIcon" }),
      _vm._v(" "),
      _c("div", { staticClass: "addressWrapper" }, [
        _c("div", [
          _vm._v(
            "\n            " +
              _vm._s(
                (_vm.currentAddress.chooseAddress == "点击设置收货地址"
                  ? ""
                  : "送至: ") + _vm.currentAddress.chooseAddress
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "rightArrow",
        style: {
          "border-color": _vm.fontColor
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }